import { render, staticRenderFns } from "./Vplayer.vue?vue&type=template&id=546dfd2d&scoped=true"
import script from "./Vplayer.vue?vue&type=script&lang=js"
export * from "./Vplayer.vue?vue&type=script&lang=js"
import style0 from "./Vplayer.vue?vue&type=style&index=0&id=546dfd2d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546dfd2d",
  null
  
)

export default component.exports